export default __webpack_public_path__ + "src/assets/images/bg_EQUINET_Premium.jpg";